// index.js
const h = "http";
const l = "localhost";
const v = "vicktoria.ai";

// Now it checks the URL OR if you've manually set the mode in your build/env
//For Production Testing swap to the bottom version of this logic
const isLocal = window.location.hostname.includes('l') && process.env.NODE_ENV !== 'production';
//const isLocal = window.location.hostname.includes('l') && process.env.NODE_ENV == 'production';

window.MY_SWITCH = {
    isDev: isLocal,
    origin: isLocal ? `${h}://${l}` : `${h}s://${v}`, // If you need that port logic
    stripePK: isLocal ? "pk_test_51Sk9V9Aya5vcTN0BovfUMi8fTuvROXwV7g76eDn6vedgCxicR7aYHJIovqyE5YEgxPqwZabrlv8Qz2gR0DzvkNiO000JjKREyn" : 
                        "pk_live_51Sk9V3Pmwra1ZTABHQ365ktOWEaxKQ3isHrwcJsKPvyySNIDzzjkKZeANdVEjy2Lj97r7w4rH6UGYmJ9Wo3V0VKW00pD4Rs0f9"
};
